var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 14.1993L11.8799 16.6547C12.5904 17.1047 13.4599 16.4395 13.2729 15.5982L12.2445 10.9809L15.6756 7.87007C16.302 7.30269 15.9654 6.22662 15.1427 6.15814L10.6271 5.75706L8.86012 1.39409C8.54225 0.60171 7.45775 0.60171 7.13988 1.39409L5.3729 5.74728L0.857274 6.14836C0.034552 6.21684 -0.302016 7.29291 0.324375 7.86029L3.7555 10.9711L2.7271 15.5884C2.54012 16.4297 3.40958 17.0949 4.12012 16.6449L8 14.1993Z",
    fill: "#FFB547"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarFull);
export default __webpack_public_path__ + "static/media/star-full.8411590798fdaa151fa136a0bfba98bc.svg";
export { ForwardRef as ReactComponent };